import React, { useEffect, useState } from 'react';
import { Button, LayerBottom, Layer, SelectList } from 'components'
import useApp from 'hooks/useApp'
import { useRecoilState } from 'recoil'
import { showTermsAgreeDetailContentsLayerState } from './states'
import Lib from 'library';
import 'suneditor/dist/css/suneditor.min.css';

const TermsAgreeDetailContents = (termsContentsLst) => {

	const App = useApp()
	const [filterLayer, setFilterLayer] = useState(false)
	const [showTermsAgreeDetailContentsLayer, setShowTermsAgreeDetailContentsLayer] = useRecoilState(showTermsAgreeDetailContentsLayerState)

	const [termsDetailLst, setTermsDetailLst] = useState(termsContentsLst)
	const [listData, setListData] = useState([])
	const [showTermsVersion, setShowTermsVersion] = useState(false)
	const [verKey, setVerKey] = useState()
	const [verValue, setVerValue] = useState()
	const [termsDtData, setTermsDtData] = useState()
	const [consts, setConts] = useState()
	const [title, setTitle] = useState()
	const [termsCd, setTermsCd] = useState()

	const openFilter = () => {
		setShowTermsVersion(true)
	}

	const closeFilter = () => {
		setFilterLayer(false)
	}

	const getData = (termsCd) => {
		//이전약관
		if (termsCd) {
			Lib.get(`/api/comm/all/ver/terms/${termsCd}`, data => {
				const newList = []
				data.forEach(item => {
					newList.push({
						key: item.termsApplyDe,
						value: item.termsVer
					})
				})
				setVerKey(newList[0].key)
				setVerValue(newList[0].value)
				setConts(data[0].termsConts)
				setTitle(data[0].termsNm)
				setListData(newList)
				setTermsDtData(data)
			})
		}
	}

	useEffect(() => {
		getData(termsCd)
	}, [termsCd])

	useEffect(() => {
		if (termsContentsLst.ctgry === "Service") {
			setTermsCd(termsContentsLst.termsContentsLst?.termsCd)
		} else {
			setTermsCd(termsContentsLst.termsEsntlDetail?.termsCd)
		}
		setTermsDetailLst(termsContentsLst)

	}, [showTermsAgreeDetailContentsLayer])

	//이전약관 리스트 중 하나를 클릭 했을 때 선택한 값을 넘겨서 새로운 약관 내용 불러와서 뿌려준다
	useEffect(() => {
		termsDtData?.map(item => {
			if (item.termsVer === verValue) {
				setConts(item.termsConts)
				setTitle(item.termsNm)
			}
		})
	}, [verValue])


	return (
		<Layer show={showTermsAgreeDetailContentsLayer} closeLayer={() => setShowTermsAgreeDetailContentsLayer(false)}>
			{termsDetailLst &&
				<div className="page">
					<div className="flex_1 padding">

						<h3>{title}</h3>
						<div className="terms-txt mt_20 sun-editor-editable" dangerouslySetInnerHTML={{ __html: consts }}></div>
						<div className="flex-justify_between align_center mt_40">
							<span style={{ color: "#999" }}>이전약관보기</span>
							<span className="flex-align_center" onClick={openFilter}>{verKey} <i className="icon icon_arrow_sm bottom ml_15" /></span>
						</div>
					</div>
					<div className="flex-shrink_0 padding">
						<Button className="btn btn--big" onClick={() => setShowTermsAgreeDetailContentsLayer(false)}>확인</Button>
					</div>
					<SelectList selected={verValue} data={listData} show={showTermsVersion} setShow={setShowTermsVersion} title="이전 약관 보기" onSelect={(key, value) => {
						setVerKey(key)
						setVerValue(value)
					}} />
				</div>
			}
		</Layer>
	)
}


export default TermsAgreeDetailContents